<template>
  <div>
    <div>
      「だれでも急上昇」はどなたでもYouTubeの急上昇に載った時の雰囲気を味わうことのできる画期的なサイトです！画面一番上の入力欄に動画URLをコピペして登録ボタンを押すだけで、急上昇リストに追加されます。自作の動画や、おすすめの動画を貼って、みんなに見てもらいましょう！なお本家YouTube様とはなんの関係もございません。
    </div>
    <div>
      お問い合わせは<a class="link" href="https://docs.google.com/forms/d/e/1FAIpQLScKjsSIBxw3fSsk-nB18Zok0nDGusbZr-o4jtCM5xgKuTmp4w/viewform?usp=sf_link" target="_blank">こちら</a>
    </div>
    <div>
      製作者の<a class="link" href="https://twitter.com/ShimageW" target="_blank">Twitter</a>
    </div>
    <ShareButton />
  </div>
</template>
<script>
import ShareButton from "@/components/ShareButton"
export default {
  name: 'About',
  components : {
    ShareButton
  },
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue